module.exports = __webpack_public_path__ + "static/img/20240419_2.5e84e0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240419_2.png
// module id = LKxv
// module chunks = 0